module.exports = __webpack_public_path__ + "18495613489769fc1c181ba60584c1cc.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/piano/13_C3.mp3
// module id = 93
// module chunks = 0